"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../elements/button/Button");
var _ChevronLeft24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronLeft24PxOutlined"));
var _ChevronRight24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronRight24PxOutlined"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _dayPicker = _interopRequireDefault(require("../../utils/dayPicker/dayPicker"));
var _replaceStringVars = _interopRequireDefault(require("../../utils/string/replaceStringVars"));
var _dayPickerModule = _interopRequireDefault(require("./day-picker.module.scss"));
var _DayPickerSelectedDay = _interopRequireDefault(require("./DayPickerSelectedDay"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DayPicker = function DayPicker(_ref) {
  var _ref$dates = _ref.dates,
    dates = _ref$dates === void 0 ? undefined : _ref$dates,
    dayPickerId = _ref.dayPickerId,
    _ref$selectedDay = _ref.selectedDay,
    selectedDay = _ref$selectedDay === void 0 ? undefined : _ref$selectedDay,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$formId = _ref.formId,
    formId = _ref$formId === void 0 ? undefined : _ref$formId,
    _ref$selectedDayMessa = _ref.selectedDayMessageTitle,
    selectedDayMessageTitle = _ref$selectedDayMessa === void 0 ? undefined : _ref$selectedDayMessa,
    _ref$selectedDayMessa2 = _ref.selectedDayMessageBody,
    selectedDayMessageBody = _ref$selectedDayMessa2 === void 0 ? undefined : _ref$selectedDayMessa2,
    _ref$selectedDayMessa3 = _ref.selectedDayMessageType,
    selectedDayMessageType = _ref$selectedDayMessa3 === void 0 ? undefined : _ref$selectedDayMessa3,
    _ref$selectedDayMessa4 = _ref.selectedDayMessageClassName,
    selectedDayMessageClassName = _ref$selectedDayMessa4 === void 0 ? undefined : _ref$selectedDayMessa4,
    _ref$selectedPage = _ref.selectedPage,
    selectedPage = _ref$selectedPage === void 0 ? 0 : _ref$selectedPage,
    _ref$onPageIndexChang = _ref.onPageIndexChange,
    onPageIndexChange = _ref$onPageIndexChang === void 0 ? function () {} : _ref$onPageIndexChang,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? undefined : _ref$containerClassNa,
    _ref$startWeekAtEarli = _ref.startWeekAtEarliestDate,
    startWeekAtEarliestDate = _ref$startWeekAtEarli === void 0 ? false : _ref$startWeekAtEarli,
    _ref$focusOnSelectedD = _ref.focusOnSelectedDayMessage,
    focusOnSelectedDayMessage = _ref$focusOnSelectedD === void 0 ? true : _ref$focusOnSelectedD,
    _ref$maxPagesToShow = _ref.maxPagesToShow,
    maxPagesToShow = _ref$maxPagesToShow === void 0 ? undefined : _ref$maxPagesToShow,
    additionalInformation = _ref.additionalInformation,
    additionalInformationOnSelect = _ref.additionalInformationOnSelect,
    daysToShowPerPage = _ref.daysToShowPerPage;
  var defaultDayPickerId = (0, _react.useId)();
  var generatedDayPickerId = dayPickerId || defaultDayPickerId;
  var _useState = (0, _react.useState)(selectedDay),
    _useState2 = _slicedToArray(_useState, 2),
    storedSelectedDay = _useState2[0],
    setStoredSelectedDay = _useState2[1];
  var _useState3 = (0, _react.useState)(selectedPage),
    _useState4 = _slicedToArray(_useState3, 2),
    storedSelectedPage = _useState4[0],
    setStoredSelectedPage = _useState4[1];
  var setDayJsWeekStart = (0, _react.useCallback)(function () {
    return !startWeekAtEarliestDate || !dates.length ? _dayjs["default"].Ls.en.weekStart = 1 : _dayjs["default"].Ls.en.weekStart = (0, _dayjs["default"])(dates[0]).day();
  }, [dates, startWeekAtEarliestDate]);
  var datesRef = (0, _react.useRef)(dates);
  var shouldAnimateRef = (0, _react.useRef)(true);
  var dayJsWeekStartRef = (0, _react.useRef)(setDayJsWeekStart());
  (0, _react.useEffect)(function () {
    if (datesRef.current !== dates) {
      dayJsWeekStartRef.current = setDayJsWeekStart();
    }
    datesRef.current = dates;
  }, [dates, setDayJsWeekStart]);
  (0, _react.useEffect)(function () {
    if (storedSelectedDay !== selectedDay) {
      setStoredSelectedDay(selectedDay);
    }
  }, [selectedDay]);
  var getDayJsWeekStart = function getDayJsWeekStart() {
    return _dayjs["default"].Ls.en.weekStart;
  };
  var renderDayHeadings = function renderDayHeadings(styles) {
    var daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var dayArray = [];
    var totalDays = 7;
    for (var i = 0; i < totalDays; i++) {
      var weekDay = getDayJsWeekStart() + i;
      var endOfWeekReached = weekDay >= totalDays;
      if (endOfWeekReached) {
        weekDay -= totalDays;
      }
      dayArray.push(/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        className: styles['c-dayPicker__dayOfWeek'],
        "data-testid": "day-picker-heading-".concat(i),
        children: daysOfWeek[weekDay]
      }, "".concat(daysOfWeek[weekDay], "-").concat(i)));
    }
    return dayArray;
  };
  var onDayButtonClick = function onDayButtonClick(date) {
    if (storedSelectedDay === date) {
      return;
    }
    setStoredSelectedDay(date);
    onChange(date);
  };
  var onDayButtonFocus = function onDayButtonFocus(evt, index) {
    if (index === storedSelectedPage) {
      return;
    }
    shouldAnimateRef.current = false;

    // scrollIntoView here ensures that browser's own "scroll focused element into view" behaviour
    // doesn't conflict with DayPicker's "scroll new page of dates into view" behaviour
    // https://www.jlpit.com/jira/browse/MARV-5533
    var el = evt.target;
    var pageToScrollTo;
    while ((_el = el) !== null && _el !== void 0 && _el.parentNode && !pageToScrollTo) {
      var _el;
      el = el.parentNode;
      if (el.tagName === 'UL') {
        pageToScrollTo = el;
      }
    }
    pageToScrollTo.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: 'start'
    });
    setStoredSelectedPage(index);
    onPageIndexChange({
      index: index,
      generatedDayPickerId: generatedDayPickerId,
      formId: formId
    });
  };
  var onNavigate = function onNavigate(direction) {
    shouldAnimateRef.current = true;
    var index = direction === 'prev' ? storedSelectedPage - 1 : storedSelectedPage + 1;
    setStoredSelectedPage(index);
    onPageIndexChange({
      index: index,
      generatedDayPickerId: generatedDayPickerId,
      formId: formId
    });
  };
  if (!dates) {
    return null;
  }
  var formattedDays = (0, _dayPicker["default"])(dates, daysToShowPerPage, maxPagesToShow);
  var canPageBackwards = storedSelectedPage !== 0;
  var canPageForwards = storedSelectedPage < formattedDays.length - 1;
  var animationStyles = shouldAnimateRef.current ? {
    left: "-".concat(100 * storedSelectedPage, "%")
  } : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames["default"])(_dayPickerModule["default"]['c-dayPicker'], containerClassName),
    "data-testid": "day-picker-container",
    "data-jlds": true,
    children: [(canPageBackwards || canPageForwards) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _dayPickerModule["default"]['c-dayPicker__nav'],
      "data-testid": "day-picker-navigation",
      children: [canPageBackwards && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_dayPickerModule["default"]['c-dayPicker__navButtonContainer'], _dayPickerModule["default"]['c-dayPicker__navButtonContainer--previous']),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
          onClick: function onClick() {
            return onNavigate('prev');
          },
          variant: "tonal-dark",
          small: true,
          IconComponent: _ChevronLeft24PxOutlined["default"],
          "data-testid": "day-picker-previous-button",
          tabIndex: "-1",
          children: "Earlier dates"
        })
      }), canPageForwards && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_dayPickerModule["default"]['c-dayPicker__navButtonContainer'], _dayPickerModule["default"]['c-dayPicker__navButtonContainer--next']),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
          onClick: function onClick() {
            return onNavigate('next');
          },
          iconPositionRight: true,
          variant: "tonal-dark",
          small: true,
          IconComponent: _ChevronRight24PxOutlined["default"],
          "data-testid": "day-picker-next-button",
          tabIndex: "-1",
          children: "Later dates"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _dayPickerModule["default"]['c-dayPicker__dates'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: _dayPickerModule["default"]['c-dayPicker__datesContainer'],
        style: animationStyles,
        "data-testid": "day-picker-grid-container",
        children: formattedDays === null || formattedDays === void 0 ? void 0 : formattedDays.map(function (page, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: _dayPickerModule["default"]['c-dayPicker__page'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              className: _dayPickerModule["default"]['c-dayPicker__pageInner'],
              children: [renderDayHeadings(_dayPickerModule["default"], index), page === null || page === void 0 ? void 0 : page.map(function (day, i) {
                var isDisabledDay = !day.active;
                var key = "".concat(day.date, "-").concat(i);
                var buttonAriaLabel = storedSelectedDay === (day === null || day === void 0 ? void 0 : day.date) ? "".concat((0, _dayjs["default"])(day === null || day === void 0 ? void 0 : day.date).format('MMMM D'), " [date], selected") : "".concat((0, _dayjs["default"])(day === null || day === void 0 ? void 0 : day.date).format('MMMM D'), " [date]");
                if (isDisabledDay) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                    className: _dayPickerModule["default"]['c-dayPicker__date'],
                    "data-testid": "day-picker-date-".concat(i),
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                      disabled: true,
                      className: (0, _classnames["default"])(_dayPickerModule["default"]['c-dayPicker__dateButton'], _dayPickerModule["default"]['c-dayPicker__dateButton--unavailable']),
                      type: "button",
                      "data-testid": "day-picker-disabled-day",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        children: (0, _dayjs["default"])(day.date).format('dddd MMMM D YYYY')
                      })
                    })
                  }, key);
                }
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                  className: _dayPickerModule["default"]['c-dayPicker__date'],
                  "data-testid": "day-picker-date-".concat(i),
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    "aria-label": buttonAriaLabel,
                    className: (0, _classnames["default"])(_dayPickerModule["default"]['c-dayPicker__dateButton'], _defineProperty(_defineProperty({}, _dayPickerModule["default"]['c-dayPicker__dateButton--selected'], storedSelectedDay === (day === null || day === void 0 ? void 0 : day.date)), _dayPickerModule["default"]['c-dayPicker__dateButton--available'], storedSelectedDay !== (day === null || day === void 0 ? void 0 : day.date))),
                    onClick: function onClick() {
                      return onDayButtonClick(day.date);
                    },
                    onFocus: function onFocus(evt) {
                      return onDayButtonFocus(evt, index);
                    },
                    disabled: disabled,
                    type: "button",
                    "data-testid": disabled ? 'day-picker-date-disabled' : undefined,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                      children: [day.labelDay, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        children: day.labelMonth
                      })]
                    })
                  })
                }, key);
              })]
            })
          }, "".concat(generatedDayPickerId).concat(index));
        })
      })
    }), storedSelectedDay && selectedDayMessageTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DayPickerSelectedDay["default"], {
      additionalInformationOnSelect: additionalInformationOnSelect,
      selectedDay: storedSelectedDay,
      selectedDayMessageTitle: (0, _replaceStringVars["default"])(selectedDayMessageTitle, {
        date: (0, _dayjs["default"])(storedSelectedDay).format('dddd D MMMM YYYY')
      }),
      selectedDayMessageBody: selectedDayMessageBody,
      selectedDayMessageType: selectedDayMessageType,
      selectedDayMessageClassName: selectedDayMessageClassName,
      focusOnSelectedDayMessage: focusOnSelectedDayMessage
    }), additionalInformation && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-testid": "day-picker-additional-information",
      children: additionalInformation
    })]
  });
};
DayPicker.propTypes = {
  dates: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  additionalInformation: _staticContentPropCheck["default"],
  additionalInformationOnSelect: _propTypes["default"].string,
  daysToShowPerPage: _propTypes["default"].number,
  dayPickerId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  formId: _propTypes["default"].string,
  onPageIndexChange: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  selectedDay: _propTypes["default"].string,
  selectedPage: _propTypes["default"].number,
  selectedDayMessageTitle: _propTypes["default"].string,
  selectedDayMessageBody: _propTypes["default"].string,
  selectedDayMessageType: _propTypes["default"].string,
  selectedDayMessageClassName: _propTypes["default"].string,
  containerClassName: _propTypes["default"].string,
  startWeekAtEarliestDate: _propTypes["default"].bool,
  focusOnSelectedDayMessage: _propTypes["default"].bool,
  maxPagesToShow: _propTypes["default"].number
};
var _default = exports["default"] = DayPicker;